/**
 * @license
 * @copyright Copyright Motili Inc., 2025 All Rights Reserved
 */

import { DASHBOARD_SCOPE, SECTION_ID } from './types';
import { createDashboardSlice } from './createDashboardSlice';

export const clientDashboardSlice = createDashboardSlice({
    name: DASHBOARD_SCOPE.CLIENT,
    initialState: {
        selectedInterval: '7 days',
        sections: {
            [SECTION_ID.openOrders]: {
                loading: false,
                error: null,
                data: {
                    count: undefined,
                    amountWithTax: undefined,
                },
            },
            [SECTION_ID.orderDetails]: {
                loading: false,
                error: null,
                data: {},
            },
            [SECTION_ID.monthlySpending]: {
                loading: false,
                error: null,
                data: {},
            },
        },
    },
});

export const { reset } = clientDashboardSlice.actions;

export default clientDashboardSlice.reducer;
